<template>
    <div v-if="vinfo">
        <!-- <headerNav title="我的" /> -->
        <div class="bgcolor">
            <div class="myheader" :style="{'background-color':$abctheme.basecolor}">
                <div class="mm">
                    <div class="icon-right" @click="$router.back(-1)">
                        <van-icon name="arrow-left" color="#fff" :size="23" />
                    </div>
                    
                    <div>{{title}}</div>
                    <!-- <div class="icon-left">
                        <van-icon name="ellipsis" color="#fff" :size="23" />
                    </div> -->
                </div>
            </div>
            <div class="mh" :style="{'background-color':$abctheme.basecolor}">

            </div>
        </div>
        
        <div>
            <div class="fheader">
                <div class="fheader-pic" @click="goto('/updatemyinfo')">
                    <div class="fheader-pic-img" v-if="vinfo.headImg">
                        <img :src="$baseurl+vinfo.headImg"/>
                    </div>
                    <div class="fheader-pic-wz">
                        <div class="fheader-pic-wz-tit">{{vinfo.nick}}</div>
                        <div class="fheader-pic-wz-stit" v-if="vinfo.signature">{{vinfo.signature}}</div>
                        <div class="fheader-pic-wz-stit" v-if="!vinfo.signature">未设置</div>
                    </div>
                </div>
                <div class="fheader-wz" >
                    <span>
                        <span class="fheader-wz-blod">{{vinfo.attentioin}}</span>
                        关注
                    </span>
                    <span>
                        <span class="fheader-wz-blod">{{vinfo.fenSi}}</span>
                        粉丝
                    </span>
                    
                    <span class="fheader-wz-right" v-if="!isown&&!vinfo.isAttentioin" @click="attention(0)">关注</span>
                     <span class="fheader-wz-right" v-if="!isown&&vinfo.isAttentioin" @click="attention(1)" :style="{'background-color':$abctheme.basecolor}">已关注</span>
                </div>
            </div>
            <div class="mytabs">
                <van-tabs :color="$abctheme.basecolor" v-model="navindex" :sticky="true" offset-top="44px" line-width="23px" :title-active-color="$abctheme.basecolor">

                         <van-tab :title="navitem.title"  v-for="(navitem,index) in navlist" :key="index">
                            <van-pull-refresh v-model="navitem.refreshing" @refresh="onRefresh">
                                <van-list
                                    v-model="navitem.loaded"
                                    :finished="navitem.loadingType == 'nomore' ? true : false"
                                    @load="loadData"
                                >
                                <div v-if="index==0">
                                    <div v-if="navitem.list&&navitem.list.length<1">
                                         <div class="recomnone">
                                            <div class="recomnone-img">
                                                <img src="../../../assets/images/fn1.jpg" />
                                            </div>
                                            <div class="recomnone-wz">
                                                你还没有发表过内容
                                            </div>
                                            <div class="recomnone-btns" v-if="isown" @click="gotoppic">
                                                <div  class="recomnone-btn">发表话题</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="navitem.list.length>0">
                                        
                                        <div v-for="(item,zindex) in navitem.list" :key="zindex">
                                            <van-swipe-cell>
                                                <comrecommend :item="item"></comrecommend>
                                                <template #right v-if="isown">
                                                    <van-button square text="删除" @click="delmm(item,0)" :color="$abctheme.basecolor"  style="height:100%" type="danger" class="delete-button" />
                                                </template>
                                            </van-swipe-cell>
                                            
                                        </div>

                                       
                                    </div>
                                   
                                    
                                </div>

                                <div v-if="index==1">
                                    <div v-if="navitem.list&&navitem.list.length<1">
                                        <div class="recomnone">
                                            <div class="recomnone-img">
                                                <img src="../../../assets/images/fn1.jpg" />
                                            </div>
                                            <div  class="recomnone-wz">
                                                你还没有发表过问题
                                            </div>
                                            <div class="recomnone-btns" v-if="isown" @click="goquestion"> 
                                                <div  class="recomnone-btn">发表问题</div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div v-if="navitem.list.length>0">

                                        <div v-for="(zitem,zindex) in navitem.list" :key="zindex">
                                            <van-swipe-cell>
                                                <comanswer :item="zitem"></comanswer>
                                                <template #right v-if="isown">
                                                    <van-button square text="删除" @click="delmm(zitem,1)" style="height:100%" :color="$abctheme.basecolor" type="danger" class="delete-button" />
                                                </template>
                                            </van-swipe-cell>
                                        </div>
                                    </div>
                                    
                                </div>

                                </van-list>
                            </van-pull-refresh>
                        </van-tab>
                    
                </van-tabs>
            </div>
            
        </div>
    </div>
</template>
<script>
import comrecommend from '@/components/common/recommend/comrecommend.vue';
import comanswer from '@/components/common/answer/comanswer.vue';
export default {
    components:{
        comrecommend,
        comanswer
    },
    data(){
        return{
            vid:undefined,
            vinfo:undefined,
            navindex:0,
            title:'我的',
            headPic:'',
            dealerName:'',
            isown:true,
            navlist: [
                {
                    title:'话题',
                    loadingType: "more",
                    loaded: false,
                    refreshing:false,
                    getparams: {
                        sorting: " sorter desc,id desc",
                        maxResultCount: 10,
                        skipCount: 0,
                        dealerId:undefined,
                    },
                    list: [],
                },
                {
                    title:'问答',
                    loadingType: "more",
                    loaded: false,
                    refreshing:false,
                    getparams: {
                        sorting: " sorter desc,id desc",
                        maxResultCount: 10,
                        dealerId:undefined,
                        skipCount: 0,
                    },
                    list: [],
                }
            ],
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    created(){
        var query=this.$route.query;
        if(!query.id)
        {
            
            this.ajax.post('/api/services/app/PhoneMemberPersonal/QueryPersonal').then(x=>
            {
                this.vinfo=x.result;
                this.title="我的";
                this.navlist[0].getparams.dealerId= this.vinfo.dealerId;
                this.navlist[1].getparams.dealerId= this.vinfo.dealerId;
            })
        }
        else
        {
            this.ajax.post('/api/services/app/PhoneMemberPersonal/QueryOtherPersonal?id='+query.id).then(x=>
            {
                this.vinfo=x.result;
                this.navlist[0].getparams.dealerId= this.vinfo.dealerId;
                this.navlist[1].getparams.dealerId= this.vinfo.dealerId;
                if(!this.vinfo.own)
                {
                    this.title=this.vinfo.nick;
                    this.isown=false;
                }
                else
                {
                    this.title="我的";
                }
            })
        }
      

    },
    methods:{
        attention(vmodel){
            if(vmodel==0)
            {
                this.ajax.post('/api/services/app/PhoneMemberAttention/Attention?AttentionId='+this.vinfo.id).then(x=>{
                        this.vinfo.isAttentioin=true;
                })
            }
            else
            {
                this.ajax.post('/api/services/app/PhoneMemberAttention/CancelAttention?AttentionId='+this.vinfo.id).then(x=>{
                        this.vinfo.isAttentioin=false;
                })
            }
        },
        delmm(item,vmodel){
             this.$dialog.confirm({title:'提示',message:'是否要删除'}).then(x=>
             {
                  let url='/api/services/app/PhoneTopic/DelTopic?id='+item.id;
                  if(vmodel==1)
                  {
                      url='/api/services/app/PhoneQuestion/DelQuestion?id='+item.id;
                  }
                  this.ajax.post(url).then(x=>
                  {
                      var vindex=this.navlist[vmodel].list.findIndex(x=>x.id==item.id);
                      this.navlist[vmodel].list.splice(vindex,1);
                  })
             });
        },
        gotoppic(){
            this.$router.push({path:'/addrecommend'})
        },
        goquestion(){
            this.$router.push({path:'/addquestion'})
        },
        goto(url)
        {
            if(this.isown)
            {
                this.$router.push({path:url});
            }
        },
        onRefresh() {
            this.loadData("refresh");
        },
        loadData(source) {
           
        let navItem = this.navlist[this.navindex];
        // let state = navItem.state;

        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
                return;
            }
        }
        if (source === "refresh") {
            this.navlist[this.navindex].list = [];
            this.navlist[this.navindex].getparams.skipCount = 0;
        }
        this.navlist[this.navindex].loadingType = "loading";
        var params = navItem.getparams;
        
        var url="/api/services/app/PhoneTopic/QueryTopicList";
        if(this.navindex==1)
        {   
            url="/api/services/app/PhoneQuestion/QueryQuestionList";
        }
        //加载数据
        this.ajax
            .post(url, params)
            .then((x) => {
            this.navlist[this.navindex].getparams.skipCount += this.navlist[this.navindex].getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.navlist[this.navindex].list = this.navlist[this.navindex].list.concat(x.result.items);
            console.log(this.navlist);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navlist[this.navindex].loadingType =
                totalcount > this.navlist[this.navindex].getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
                this.$set(this.navlist[this.navindex], "loaded", false);
                this.navlist[this.navindex].refreshing = false;
            });
        },
        goto(url){
            this.$router.push({path:url});
        }
    }
}
</script>
<style lang="scss" scoped>

.myheader{
    background-color: #91b0c5;
    text-align: center;
    position: fixed;
    top:0;
    left:0;
    right:0;
    font-size: 18px;
    padding-top:5px;
    color:#fff;
    height: 39px;
    z-index:999999999;
}
.icon-right{
    position: absolute;
    left: 5px;
}
.icon-left{
    position: absolute;
    top:5px;
    right: 5px;
}

.mh{
    min-height: 70px;
    width: 100%;
    background-color: #91b0c5;
    z-index:9999999999;
}
.fheader{
    background-color: #fff;
    font-size: 12px;
    padding-left:20px;
    padding-top:5px;
}


.fheader-pic{
    position: relative;
    min-height: 70px;
    padding-left:130px;
}
.fheader-pic-img{
    position: absolute;
    left:0px;
    top:-31px;
    z-index:88888888;
}
.fheader-pic-img img{
    width: 85px;
    height: 85px;
    padding: 5px;
    border-radius: 50%;
    background-color: #fff;
}
.fheader-pic-wz-tit{
    font-size: 18px;
    font-weight: bold;
}
.fheader-pic-wz-stit{
    font-size: 12px;
    color:#626262;
}
.fheader-wz{
    font-size: 15px;
    color:#626262;
    min-height: 25px;
}
.fheader-wz-blod{
    font-weight: bold;
    color:black;
}
.fheader-wz-right{
    float: right;
    font-size: 14px;
    margin-right: 15px;
    color:white;
    background: #cdcdcd;
    padding: 2px 20px;
    border-radius: 4px;
}
.mytabs{
    height: 700px;
    
}
.recomnone{
    padding-top:90px;
    text-align: center;
    padding-bottom:10px;
    background-color: #fff;
}

.recomnone-img img{
    width: 150px;
}
.recomnone-wz{
    color:#e6e6e6;
    font-size: 13px;
    margin-bottom: 55px;
}

.recomnone-btn{
    color:coral;
    border: 1px solid coral;
    border-radius: 50px;
    font-size: 14px;
    padding: 8px;
    display: inline-block;
}
</style>